import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import axios from './util/axios'
import storage from './util/storage'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// import store from './store'
const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
app.mixin({
  methods: {
    $axios: axios,
    $setStorage: storage.set,
    $getStorage: storage.get,
    $removeStorage: storage.remove,
    $clearStorage: storage.clear,
  }
})

app.use(ElementPlus, {
  locale: zhCn,
})


app.use(router).mount('#app')
